import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './TabsCarouselComponentListing.css';
import React, { useEffect, useState } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import Switch from './components/Switch';
import { commonStyles as EventsCommonStyles } from '../15_Events/Events';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import RouterLink from '../atoms/RouterLink';
import EventBlock from '../15_Events/components/EventBlock';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import { useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { TYPE } from '../../utils/constants';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNotNil } from '../../utils/IsNil';
import getListing from '../../utils/getListing';
export var TabsCarouselComponentListing = function TabsCarouselComponentListing(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var location = useLocation();
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    typesTabs = _React$useState2[0],
    setTypesTabs = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    mappedTypes = _React$useState4[0],
    setMappedTypes = _React$useState4[1];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var carouselBackgroundColor = BackgroundColorHex ? BackgroundColorHex : "transparent";
  var datasourceItems = get(fields, 'data.datasource.items', {});
  var datasourceTitle = get(fields, 'data.datasource.title.jss');
  var queryParams = qsToObject(location.search);
  var queriesType = canUseDOM && TYPE && queryParams[TYPE] ? queryParams[TYPE].replaceAll("+", " ") : null;
  var messageSearchResultEmpty = get(fields, 'data.contextItem.messageSearchResultEmpty.value', '');
  var socialSharing = get(fields, 'data.socialSharing');
  var countryItems = get(fields, 'data.countries.countryValues') || [];
  var dictionary = get(fields, 'data.dictionary');
  var bookNowText = getDictionaryItem(dictionary, 'bookNow') || '';
  var expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '';
  var termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '';
  var fromText = getDictionaryItem(dictionary, 'from') || '';
  var offText = getDictionaryItem(dictionary, 'off') || '';
  var moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '';
  var ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';
  var curatorPick = getDictionaryItem(dictionary, 'Curatorspick') || '';
  var item = get(fields, "data.datasource.items")[mappedTypes[queriesType]];
  var hitsPerPage = get(item, 'count.jss.value') || 10;
  var ctaLabel = get(item, 'ctaLabel.jss.value');
  var ctaLink = get(item, 'ctaLink.jss.value.href');
  var algoliaIndexes = get(params, 'SearchIndex');
  var eventsAnalytics = get(item, 'data.eventsAnalytics') || [];
  var typeValue = get(item, 'contentType.types.template.targetItem.value');
  var filterValues = get(item, 'filters.values') && get(item, 'filters.values').length ? get(item, 'filters.values')[0] : null;
  var fieldNameItem = filterValues ? get(filterValues, 'fieldNameItem.item.fieldName.value') : null;
  var tagsToDisplayValues = filterValues ? get(filterValues, 'tagsToDisplay.values') : null;
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var algoliaRequest = function algoliaRequest() {
    var types = "type:".concat(typeValue);
    var optionsValues = function optionsValues() {
      return tagsToDisplayValues.map(function (tag) {
        return "".concat(fieldNameItem, ":").concat(tag.title.value);
      });
    };
    var facetFilters = isNotNil(fieldNameItem) && isNotNil(tagsToDisplayValues) ? [types].concat(_toConsumableArray(optionsValues())) : [types];
    var itemFilters = {
      facetFilters: facetFilters,
      hitsPerPage: hitsPerPage > 10 ? 10 : hitsPerPage
    };
    getListing(algoliaIndexes, itemFilters).then(function (response) {
      setItems(response.hits);
    }).catch(function (error) {
      console.log("error", error);
    });
  };
  React.useEffect(function () {
    var types = datasourceItems.reduce(function (acc, item, index) {
      var key = get(item, 'contentType.types.template.targetItem.value', []);
      acc[key] = index;
      return acc;
    }, {});
    setMappedTypes(types);
    setTypesTabs(datasourceItems.map(function (item) {
      return get(item, 'contentType.types.template.targetItem.value', []);
    }));
  }, []);
  useEffect(function () {
    if (isNotNil(typeValue)) {
      algoliaRequest();
    }
  }, [location.search, typeValue]);
  if (!fields) {
    console.warn('TabCarouselComponentListing component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TabCarouselComponentListing component is empty: please provide data source]");
    }
    return null;
  }
  var renderItems = function renderItems() {
    if (!items.length) {
      return [];
    }
    return items.map(function (event, index) {
      if (event.type.some(function (v) {
        return ~v.indexOf('Event');
      })) {
        return /*#__PURE__*/React.createElement(EventBlock, {
          key: index,
          event: event,
          curatorsCopy: curatorPick,
          hostLink: '',
          lang: 'en',
          themeValues: [],
          analytics: {
            eventsAnalytics: eventsAnalytics,
            params: params
          }
        });
      }
      if (event.type.some(function (v) {
        return ~v.indexOf('Offer And Deal');
      })) {
        return /*#__PURE__*/React.createElement(OfferAndDeal, {
          key: index,
          deal: event,
          eventsAnalytics: eventsAnalytics,
          gridMode: false,
          params: params,
          rtl: rtl,
          fromText: fromText,
          offText: offText,
          moreInfoText: moreInfoText,
          expiresSoonText: expiresSoonText,
          bookNowText: bookNowText,
          termsAndConditionsText: termsAndConditionsText,
          socialSharing: socialSharing,
          ratingTextStars: ratingTextStars,
          countryItems: countryItems
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: {
      background: carouselBackgroundColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-11"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    field: datasourceTitle
  }), /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots,
      state = _ref2.state,
      moveToSlide = _ref2.moveToSlide;
    return /*#__PURE__*/React.createElement(React.Fragment, null, typesTabs.length ? /*#__PURE__*/React.createElement(Switch, {
      tagsToDisplay: typesTabs,
      fields: fields,
      rtl: rtl,
      moveToSlide: moveToSlide
    }) : null, Object.keys(mappedTypes).length ? /*#__PURE__*/React.createElement(StyledWrapper, {
      rtl: rtl
    }, /*#__PURE__*/React.createElement("div", {
      className: "tab-carousel__wrapper ".concat(rtl && get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'item-rtl-carousal-fix' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "top-buttons"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      tealiumClickFunc(tealiumMergeClickData({}, params));
    }), renderNextButton(function () {
      tealiumClickFunc(tealiumMergeClickData({}, params));
    })))), items && items.length ? /*#__PURE__*/React.createElement("div", {
      className: "module-group no-padding-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-lg-12",
      style: {
        display: 'block'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        large: {
          breakpoint: {
            max: 10000,
            min: 1601
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1600,
            min: 992
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 991,
            min: 768
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 767,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    }, function () {
      return tealiumClickFunc(tealiumMergeClickData({}, params));
    }))))) : null, !items.length && /*#__PURE__*/React.createElement("h4", {
      className: "message-search-result-empty",
      dangerouslySetInnerHTML: {
        __html: messageSearchResultEmpty
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "module-group no-padding-bottom"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "footer-buttons"
    }, /*#__PURE__*/React.createElement("div", {
      className: "module-group read-more__row"
    }, ctaLabel && ctaLink && /*#__PURE__*/React.createElement(RouterLink, {
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['discoverMoreAnalytics'], params), ctaLabel);
      },
      className: "btn btn-primary",
      title: ctaLabel,
      href: ctaLink,
      linktype: "external",
      openInSameTab: true
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text"
    }, ctaLabel))), items && items.length ? /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickData({}, params));
    })) : null))))) : null);
  })));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    style = _ref3.style;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: " ".concat(commonStyles, " ").concat(EventsCommonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    style: style
  }, children);
};
var commonStyles = "c11wp7dl";
var ltrStyles = "l1imdw8e";
var rtlStyles = "r1q8q42q";
export default TabsCarouselComponentListing;